import { render } from "./IconReplay.vue?vue&type=template&id=fed37f72"
import script from "./IconReplay.vue?vue&type=script&lang=js"
export * from "./IconReplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__